import React, { Component } from 'react'
import { Popover, withStyles } from '@material-ui/core';
import { toCurrency, Guid } from '../../helpers';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBalanceScale } from '@fortawesome/pro-light-svg-icons';

const euro = '€';
const dollar = '$';
const rand = 'R';

const styles = theme => ({
    popover: {
        display: 'inline-block',
        pointerEvents: 'none',
        width: 'auto'
    },
    paper: {
        display: 'inline-block',
        padding: theme.spacing.unit,
        width: 'auto'
    },
});

const getCurrencySymbol = (currency_code) => {
    switch (currency_code) {
        case "EUR":
            return euro;
        case "USD":
            return dollar;
        case "ZAR":
        default:
            return rand;
    }
}

class CurrencyText extends Component {
    state = {
        anchorEl: null
    };

    id = Guid();

    handlePopoverOpen = event => {
        this.setState({ anchorEl: this.txtEl });
        // console.log(this.txtEl);
        // console.log(event.currentTarget);
    }
    handlePopoverClose = () => this.setState({ anchorEl: null });

    getRemaining = () => {
        const { TextComponent = "span" } = this.props;
        switch (this.props.currency) {
            case "EUR":
                return [<TextComponent style={{ ...this.props.style }} key="1">{toCurrency(this.props.value * this.props.forex.eurTo.zar, rand)}</TextComponent>, <br key="br" />, <TextComponent style={{ ...this.props.style }} key="2">{toCurrency(this.props.value * this.props.forex.eurTo.usd, dollar)}</TextComponent>];
            case "USD":
                return [<TextComponent style={{ ...this.props.style }} key="1">{toCurrency(this.props.value * this.props.forex.usdTo.zar, rand)}</TextComponent>, <br key="br" />, <TextComponent style={{ ...this.props.style }} key="2">{toCurrency(this.props.value * this.props.forex.usdTo.eur, euro)}</TextComponent>];
            case "ZAR":
            default:
                return [<TextComponent style={{ ...this.props.style }} key="1">{toCurrency(this.props.value * this.props.forex.zarTo.usd, dollar)}</TextComponent>, <br key="br" />, <TextComponent style={{ ...this.props.style }} key="2">{toCurrency(this.props.value * this.props.forex.zarTo.eur, euro)}</TextComponent>];
        }
    }

    render() {
        const { currency = "ZAR", value, requireTimeSpecific, timestamp, classes, TextComponent = "span", icon = false } = this.props;

        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);

        return [
            <TextComponent
                key="text"
                ref={txt => this.txtEl = txt}
                aria-owns={open ? 'mouse-over-popover-' + this.id : undefined}
                aria-haspopup="true"
                onMouseEnter={this.handlePopoverOpen}
                onMouseLeave={this.handlePopoverClose}
                style={{ ...this.props.style }}
            >
                {this.props.children || toCurrency(value, getCurrencySymbol(currency))}
                {
                    icon ?
                        <FontAwesomeIcon icon={faBalanceScale} size="sm" style={{ marginLeft: 10 }} />
                        :
                        null
                }
            </TextComponent>,
            <Popover
                key="popover"
                id={"mouse-over-popover-" + this.id}
                className={classes.popover}
                classes={{ paper: classes.paper }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                style={{ ...this.props.popoverStyle }}
                onClose={this.handlePopoverClose}
                disableRestoreFocus
            >
                {this.getRemaining()}
            </Popover>
        ]
    }
}

const mapStateToProps = (state) => {
    return {
        forex: state.forex.latest
    };
}

export default withStyles(styles)(connect(mapStateToProps)(CurrencyText));
